@use '../../../../design-tokens/border-radius/border-radius' as *;
@use '../../../../design-tokens/typography/typography' as *;

@layer design-system {
  $timing-function-base: cubic-bezier(0.4, 0, 0.2, 1);

  .iconWrapper {
    display: flex;

    svg {
      fill: var(--icon-default);
    }
  }

  .mainLabel {
    color: var(--text-default);
  }

  .itemBackground {
    @include border-radius-r1;
    position: absolute;
    inset: 0;
    pointer-events: none;
    width: 100%;
    transition: transform 300ms $timing-function-base;
  }

  .subItem {
    @include typography-v2-body-sm;
    @include border-radius-r1;
    position: relative;
    z-index: 1;
    border: none;
    white-space: nowrap;
    cursor: pointer;
    outline: none;
    gap: 8px;
    display: flex;
    align-items: center;
    width: 100%;
    height: auto;
    justify-content: center;
    padding: 6px 8px;
    color: var(--text-default);
    background-color: inherit;

    &:hover,
    &:focus-visible {
      background-color: var(--surface-hover);
    }

    &.sideBarExpanded {
      justify-content: flex-start;
    }

    &.isActive {
      background-color: var(--surface-active);
    }
  }
}
